export default class DateUtils {
  static getCreatedAtMillSeconds(value) {
    if (!value) {
      return 0
    }
    const milliseconds = Date.parse(value)
    return Number.isFinite(milliseconds) ? milliseconds : 0
  }
}
